import React, {useContext, useEffect, useState} from 'react';
import {
    Alert,
    Box,
    List,
    ListItem,
    ListItemSecondaryAction,
    Switch,
    Typography,
    Tooltip,
    Paper,
    Button,
    Snackbar,
    CircularProgress,
    AlertTitle,
} from "@mui/material";
import ListItemText from "@mui/material/ListItemText";
import {PAContext} from "../../../Services/PAContext";
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import SettingsSuggestIcon from '@mui/icons-material/SettingsSuggest';
import ListItemIcon from "@mui/material/ListItemIcon";
import NotificationsActiveIcon from '@mui/icons-material/NotificationsActive';



// Modern Firebase Modular Imports
import { initializeApp, getApps, getApp } from 'firebase/app';
import { getMessaging, getToken, onMessage } from 'firebase/messaging';



/**
 * FIREBASE CONFIGURATION (Modular Setup)
 */
const firebaseConfig = {
    apiKey: "AIzaSyBteakXsjk3XSUL16-jI5v2qdW3PIKZzDg",
    authDomain: "plannedadventurewebsitereact.firebaseapp.com",
    projectId: "plannedadventurewebsitereact",
    storageBucket: "plannedadventurewebsitereact.firebasestorage.app",
    messagingSenderId: "1047489783931",
    appId: "1:1047489783931:web:f1325891116723bcac5ade",
    measurementId: "G-X1D5X7HH11"
};



// Initialize Firebase once
const app = getApps().length === 0 ? initializeApp(firebaseConfig) : getApp();
const messaging = typeof window !== 'undefined' ? getMessaging(app) : null;




function Notifications({processingNotifications, setProcessingNotifications, snackbar, setSnackbar}){

    const { dataArray, sendSocketMessage } = useContext(PAContext);
    const { Account } = dataArray;

    const getPushStatus = () => {
        if (typeof window === 'undefined' || !('Notification' in window)) {
            console.log("!!!!!! PUSH not supported");
            return { status: 'unsupported', label: 'Not supported', color: 'error' };
        }

        console.log("!!!!!! PUSH IS supported");

        const permission = Notification.permission;
        console.log("!!!!!! PERMISSION status : ", permission);

        if (permission === 'denied') return { status: 'blocked', label: 'Blocked by browser', color: 'error' };
        if (permission === 'granted') return { status: 'active', label: 'Push Active', color: 'success' };
        return { status: 'off', label: 'Push Disabled', color: 'info' };
    };

    const [prefs, setPrefs] = useState({ push_enabled: false, email_enabled: true });
    const [browserStatus, setBrowserStatus] = useState(getPushStatus());
    const [isProcessing, setIsProcessing] = useState(false);

    const [pushToken, setPushToken] = useState("");

    // Listen for foreground messages (Modern v9+ style)
    useEffect(() => {
        if (!messaging) return;
        const unsubscribe = onMessage(messaging, (payload) => {
            console.log('Foreground Message received: ', payload);
            // You can trigger a custom UI toast here


        });
        return () => unsubscribe();
    }, []);

    const handlePushActivation = async () => {
        setIsProcessing(true);
        //setError(null);

        try {
            if (!('serviceWorker' in navigator)) {
                throw new Error("Service Workers not supported.");
            }

            const permission = await Notification.requestPermission();

            if (permission === 'granted' && messaging) {
                // getToken acts as the 'request' mechanism
                const currentToken = await getToken(messaging, {
                    vapidKey: 'BMc5kTHSoMmafW0t37rmnUqjvJM_urbkeHdkqRHQois-xOGj_SoQoZGyRyzKwH0WGHhf2lFotoRggm7DHtG8x88' // Replace with your actual VAPID key from Firebase Console
                });

                if (currentToken) {
                    console.log("FCM Token Generated:", currentToken);

                    setPushToken(currentToken);

                    const _send_string = {};
                    _send_string.action = "E_updateAccountPersonalInfoNotificationPUSH";
                    _send_string.attendee_id = Account.id;
                    _send_string.enable_push = true;
                    _send_string.push_token = currentToken;

                    setPrefs(prev => ({ ...prev, push_enabled: true }));
                } else {


                    throw new Error("No registration token available. Request permission to generate one.");
                }
            } else {

                const _send_string = {};
                _send_string.action = "E_updateAccountPersonalInfoNotificationPUSH";
                _send_string.attendee_id = Account.id;
                _send_string.enable_push = false;
                _send_string.push_token = pushToken;

                setPrefs(prev => ({ ...prev, push_enabled: false }));
            }
        } catch (err) {
            console.error("Token Request Error:", err);
            //setError(err.message);
            setPrefs(prev => ({ ...prev, push_enabled: false }));
        } finally {
            setIsProcessing(false);
            setBrowserStatus(getPushStatus());
        }
    };

    const handlePUSHToggle = (key) => {
        if (key === 'push_enabled' && !prefs.push_enabled) {
            handlePushActivation();
        } else {
            setPrefs(prev => ({ ...prev, [key]: !prev[key] }));
        }
    };
    const handleToggle = (key) => {
        setPrefs(prev => ({ ...prev, [key]: !prev[key] }));
    };


    const getStatusIcon = () => {
        switch (browserStatus.status) {
            case 'active': return <CheckCircleOutlineIcon color="success" />;
            case 'blocked': return <ErrorOutlineIcon color="error" />;
            default: return <SettingsSuggestIcon color="disabled" />;
        }
    };


    const [isPushSupported,setIsPushSupported] = useState(getPushStatus());
    const [enablePush,setEnablePush] = useState(Account.push_notifications || false);

    // Check for Push Support on mount
    useEffect(() => {
        const supported = 'PushManager' in window;
        setIsPushSupported(supported);
    }, []);






    const [activities,setActivities] = useState(Account.notifications.activities || false);
    const [flights,setFlights] = useState(Account.notifications.flights || false);
    const [lodging,setLodging] = useState(Account.notifications.lodging || false);
    const [meals,setMeals] = useState(Account.notifications.meals || false);
    const [messages,setMessages] = useState(Account.notifications.messages || false);
    const [supplies,setSupplies] = useState(Account.notifications.supplies || false);
    const [to_do,setTodo] = useState(Account.notifications.to_do || false);
    const [daily,setDaily] = useState(Account.notifications.daily || false);
    const [daysLeading,setDaysLeading] = useState(Account.notifications.days_leading || false);

    function handleSaveAccountNotifications() {
        console.log("Saving Notification settings:");

        setProcessingNotifications(true);

        const _sendString = {
            action: "E_updateAccountPersonalInfoNotifications",
            // Pass the object directly
            notifications: {
                activities,
                flights,
                lodging,
                meals,
                messages,
                supplies,
                to_do,
                daily,
                days_leading: daysLeading // consistent naming with DB
            }
        };

        sendSocketMessage(_sendString);

    }


    return (
        <>
            {/* SAVE Button */}
            <Box sx={{ p: 2, display: 'flex', justifyContent: 'flex-end', gap: 2}}>
                <Button
                    variant="contained"
                    disabled={processingNotifications}
                    startIcon={
                        processingNotifications ? (
                            <CircularProgress size={18} color="inherit" />
                        ) : (
                            <i className="icon-floppy-disk" />
                        )
                    }
                    onClick={handleSaveAccountNotifications}
                    sx={{
                        bgcolor: '#f09637',
                        '&:hover': { bgcolor: '#d9822b' },
                        // Ensure the button maintains a consistent width when switching to the spinner
                        minWidth: '140px'
                    }}
                >
                    Save Notifications
                </Button>
            </Box>

            <Paper variant="outlined" sx={{ p: 3, mb: 3, borderRadius: '12px', borderStyle: 'dashed', borderColor: !isPushSupported ? 'error.light' : 'warning.light', bgcolor: !isPushSupported ? '#fff5f5' : '#fff9f0' }}>
                <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                    <Box sx={{ flexGrow: 1, pr: 2 }}>
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                            <Typography variant="h6" sx={{ fontWeight: 700 }}>
                                Enable Push Messaging
                            </Typography>
                            {!isPushSupported && (
                                <Tooltip title="Your current browser doesn't support PushManager.">
                                    <InfoOutlinedIcon sx={{ color: 'error.main' }} />
                                </Tooltip>
                            )}
                        </Box>
                        <Typography variant="body2" color="text.secondary">
                            Stay updated even when you're not in the app. Receive critical alerts directly on your device.
                        </Typography>
                    </Box>
                    <Box>
                        <Switch
                            size="large"
                            checked={enablePush}
                            onChange={(e) => setEnablePush(e.target.checked)}
                            color="warning"
                            disabled={!isPushSupported}
                        />
                    </Box>
                </Box>
                {!isPushSupported && (
                    <Alert severity="error" sx={{ mt: 2, py: 0 }}>
                        Browser Push API is not available on this device.
                    </Alert>
                )}
            </Paper>

            <Typography variant="subtitle2" sx={{ color: 'text.secondary', fontWeight: 700, mb: 2, textTransform: 'uppercase', letterSpacing: '0.05em' }}>
                Notification Categories
            </Typography>

            <List sx={{ width: '100%', bgcolor: 'background.paper' }}>

                <ListItem key="activities" secondaryAction={<Switch checked={activities} onChange={(e) => setActivities(e.target.checked)} color="warning" />}>
                    <ListItemText primary="Activities" secondary="When the host adds activities that include you." />
                </ListItem>
                <ListItem key="flights" secondaryAction={<Switch checked={flights} onChange={(e) => setFlights(e.target.checked)} color="warning" />}>
                    <ListItemText primary="Flights" secondary="Flight additions, 24-hour alerts, and status updates." />
                </ListItem>
                <ListItem key="lodging" secondaryAction={<Switch checked={lodging} onChange={(e) => setLodging(e.target.checked)} color="warning" />}>
                    <ListItemText primary="Lodging" secondary="Flight additions, 24-hour alerts, and status updates." />
                </ListItem>
                <ListItem key="meals" secondaryAction={<Switch checked={meals} onChange={(e) => setMeals(e.target.checked)} color="warning" />}>
                    <ListItemText primary="Meals" secondary="Flight additions, 24-hour alerts, and status updates." />
                </ListItem>
                <ListItem key="messages" secondaryAction={<Switch checked={messages} onChange={(e) => setMessages(e.target.checked)} color="warning" />}>
                    <ListItemText primary="Messages" secondary="Flight additions, 24-hour alerts, and status updates." />
                </ListItem>
                <ListItem key="supplies" secondaryAction={<Switch checked={supplies} onChange={(e) => setSupplies(e.target.checked)} color="warning" />}>
                    <ListItemText primary="Supplies" secondary="Flight additions, 24-hour alerts, and status updates." />
                </ListItem>
                <ListItem key="to_do" secondaryAction={<Switch checked={to_do} onChange={(e) => setTodo(e.target.checked)} color="warning" />}>
                    <ListItemText primary="To Do" secondary="Flight additions, 24-hour alerts, and status updates." />
                </ListItem>

                <ListItem key="daily" secondaryAction={<Switch checked={daily} onChange={(e) => setDaily(e.target.checked)} color="warning" />}>
                    <ListItemText primary="Daily" secondary="Flight additions, 24-hour alerts, and status updates." />
                </ListItem>
                <ListItem key="days_leading" secondaryAction={<Switch checked={daysLeading} onChange={(e) => setDaysLeading(e.target.checked)} color="warning" />}>
                    <ListItemText primary="Days Leading" secondary="Flight additions, 24-hour alerts, and status updates." />
                </ListItem>

            </List>

            <Snackbar
                open={snackbar.open}
                autoHideDuration={3000}
                onClose={() => setSnackbar({ ...snackbar, open: false })}
                anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
            >
                <Alert severity={snackbar.severity} sx={{ width: '100%', borderRadius: '12px', fontWeight: 600 }}>{snackbar.message}</Alert>
            </Snackbar>
        </>

    )

}

export default Notifications;